export enum CycleCheckerEnum {
    APPROVED = 'APPROVED',
    NOT_APPROVED = 'NOT_APPROVED'
}